import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useOperatorListUiState = () => {
  const errdialog = ref(false);
  const errMessage = ref("");
  const editPage = ref(false);
  const confirmPage = ref(false);
  const confirmDeleteDialog = ref(false);
  const overlay = ref(false);

  // パネル
  const panel = ref<number[]>([0]);

  const openListPage = (): void => {
    editPage.value = false;
    confirmPage.value = false;
  };

  return {
    errdialog,
    errMessage,
    editPage,
    confirmPage,
    confirmDeleteDialog,
    overlay,
    panel,
    openListPage,
  };
};
